import { useMediaQuery, Grid } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import PropTypes from 'prop-types';

import { Image } from '@/src/components/atoms';
import { SectionHeader } from '@/src/components/molecules';
import { SectionAlternate } from '@/src/components/organisms';

const useStyles = makeStyles(theme => ({
  pagePaddingTop: {
    paddingTop: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing(5),
    },
  },
  image: {
    width: 600,
    [theme.breakpoints.down('sm')]: {
      width: 300,
    },
  },
}));

function Hero(props) {
  const { className, ...rest } = props;

  const classes = useStyles();
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), { defaultMatches: true });

  return (
    <SectionAlternate className={classes.pagePaddingTop}>
      <div className={className} {...rest}>
        <Grid container justifyContent="space-between" alignItems="center" spacing={isMd ? 4 : 2}>
          <Grid item xs={12} md={6} data-aos="fade-up">
            <SectionHeader
              title="Carreiras"
              subtitle="Acompanhe as oportunidades de se juntar ao nosso time e ajudar a fazer parte da construção do futuro da educação."
              align={isMd ? 'left' : 'center'}
              disableGutter
              titleVariant="h3"
            />
          </Grid>
          <Grid
            item
            container
            justifyContent="center"
            alignItems="center"
            xs={12}
            md={6}
            data-aos="fade-up">
            <Image
              src="/images/illustrations/careers/hero.svg"
              alt="Carreiras"
              className={classes.image}
            />
          </Grid>
        </Grid>
      </div>
    </SectionAlternate>
  );
}

Hero.propTypes = {
  className: PropTypes.string,
};

export default Hero;
